import mapboxgl from 'mapbox-gl';

import { MapCoordinate } from "../interfaces/map-coordinate";
import { MapMarker } from '../interfaces/map-marker';
import { parseToLocalDateTimeFromUtc, parseToLocalTimeFromUtc } from '@/helpers/utilities';
import { formatTrackingToMapCoordinate } from '@/helpers/formats';
import { VehicleTrackingDto } from '@/dtos';

export const getDefaultMarker = (lat: number, lon: number) => {
    const mapMarker: MapCoordinate = {
        coordinate: [lon, lat],
        isPrimaryColor: true,
        name: 'default-marker'
    }

    return mapMarker;
}


export const addMarkerOnMap = (map: mapboxgl.Map, coord: MapCoordinate): MapMarker => {
    const marker = new mapboxgl.Marker({ color: coord.color ?? ((coord.isPrimaryColor) ? "#10FF04" : '#F53222') })
        .setLngLat(coord.coordinate)
        .addTo(map);

    const popup = new mapboxgl.Popup({ offset: 25 })
        .setHTML(coord.name);

    marker.setPopup(popup);

    const mapMarker: MapMarker = {
        identification: coord.name,
        type: coord.type,
        marker: marker
    }

    return mapMarker;
}

export const addBusMarkerOnMap = (map: mapboxgl.Map, vehicleTracking: VehicleTrackingDto): MapMarker => {
    const el = document.createElement('div');

    el.style.backgroundImage = `url(${require('@/assets/icons/bus.png')})`;
    el.style.width = '25px';
    el.style.height = '25px';
    el.style.backgroundSize = '100%';

    const coordMap = formatTrackingToMapCoordinate(vehicleTracking.tracking);

    const marker = new mapboxgl.Marker(el)
        .setLngLat(coordMap.coordinate)
        .addTo(map);

    const popup = new mapboxgl.Popup({ offset: 25 })
        .setHTML(`
            <div class='map-component-popup-title'>
                <span class="material-symbols-outlined">directions_bus</span>
                <span>${vehicleTracking.vehicle}</span>
            </div>
            <div>
                <span class="material-symbols-outlined">schedule</span>
                <span>${parseToLocalDateTimeFromUtc(vehicleTracking.tracking.date + " " + vehicleTracking.tracking.hour)}</span>
            </div>
            <div>
                <span class="material-symbols-outlined">speed</span>
                <span style="font-weight:bold">${vehicleTracking.tracking.speed} Km/h</span>
            </div>
        `);


    marker.setPopup(popup);

    const mapMarker: MapMarker = {
        identification: vehicleTracking.vehicle + "-" + vehicleTracking.vehicle_id,
        marker: marker
    }

    return mapMarker;
}
